export const saveToken = (token: string): void => {
  localStorage.setItem('token', token);
};

export const getToken = (): string | undefined => {
  const tokenFromLocalStorage = localStorage.getItem('token');
  if (!tokenFromLocalStorage) return;
  return tokenFromLocalStorage.startsWith('Bearer')
    ? tokenFromLocalStorage
    : `Bearer ${tokenFromLocalStorage}`;
};

export const removeToken = (): void => localStorage.removeItem('token');
